let resumeData = {
  name: "Mohammed Imtiyaz",
  role: "Front End React Developer",
  linkedinId: "mohammedimtiyaz-01",
  roleDescription:
    " And I'm Passionate, detail-oriented, enthusiastic software professional. Always Seeking to deliver high performant,scalable & secure web application with quality development",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/mohammedimtiyaz-01/",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "https://github.com/mohammedimtiyaz-1/",
      className: "fa fa-github",
    },
    {
      name: "mail",
      url: "mohammedimtiyaz.jk@yahoo.com",
      className: "fa fa-envelope",
    },
  ],
  aboutme:
    "I am 6+ years Experienced Web Front-End Developer | Expert in React Ecosystem | Crafting Aesthetic, Scalable, Secure UI for Enhanced UX | Proven track record from project scripting to scaling for millions of users | Passionate about Productive DX, Releases, and End-User Monitoring | Design Systems to Component Libraries for Harmonious Interfaces | Advocate of Secure Web Applications with a Challenge-Reward Philosophy | Tech Article Writer, Open Source Contributor, and Part-Time Mentor.",
  phone: "8197197997",
  education: [
    {
      UniversityName: "MS Ramaiah Institute of Technology,Bangalore",
      specialization: "M.Tech in Computer Science",
      MonthOfPassing: "Aug",
      YearOfPassing: "2018",
      CGPA: "8.13",
    },
    {
      UniversityName: "S.D.M.C.E.T, Dharwad ",
      specialization: "B.E. in Information Science",
      MonthOfPassing: "May",
      YearOfPassing: "2016",
      CGPA: "8.55",
    },
  ],
  work: [
    {
      CompanyName: "Decathlon",
      specialization: "Senior Front Developer",
      MonthOfLeaving: "",
      tech: ["Javascript", "Html5", "Css3", "Git", "Github"],
      YearOfLeaving: "...Presently working",
      Achievements: [
        "Experience on building the high traffic customer facing Website - Decathlon Online Shopping App (DOSA) website ecommerce.",
        "Experienced on the Agile scrum method and participate in scrum ceremonies.",
        "Responsible for writing unit tests, isolated component for visual testing, performing code reviews.",
        "Participating in design discussions & steam-lining architectural overviews.",
        "Follow standard Git flow, Peer code review, code quality using SONAR & document the releases.",
        "Experience in designing, building performance website with metric analysis.",
        "Designed with mobile first strategy & responsive to all the screen factors.",
        "Maintaining website consistency and pro actively handling incidents.",
        "Familiar with the CI/CD flows and deployment strategy.",
        "Able to maintain server configuration and understand the scalability trade-offs.",
        "Excellent communication and collaborate on multi-functional cross teams",
      ],
      leave: "...Presently working",
      join: "May 2021",
    },
    {
      CompanyName: "Signify Innovatons Lab (formerly Philips Lighting)",
      specialization: "Development Engineer | Front End React",
      join: "Aug 2018",
      leave: "May 2021",
      tech: ["Javascript", "Html5", "Css3", "Git", "Github"],
      Achievements: [
        "Transformation of design wireframes to responsive web application and implementation of reusable UI components using React.js",
        "Responsible for Integration of REST APIs to UI &incorporated unit tests with Jest.",
        "Incorporated AWS S3 for static webhosting, route53 for DNS & CloudFront for CDN.",
        "Implemented and improved scripts for building and publishing UI builds CI/CD for different staging environments using PowerShell and batch.",
        "Responsible for configuring unit tests ,code coverage and Reporting it on Teamcity.",
        "Configured and Implemented UI Automation testing using Cypress.",
        "Responsible for maintaining open source security and license compliance using whitesource.",
        "Ensured uninterrupted flow of CI/CD & reduced build time in CI tools and reduced build time",
      ],
    },
    // {
    //   CompanyName: "Philips Lighting",
    //   specialization: "Development Engineer | Front End React",
    //   join: "Aug 2018",
    //   leave: "May 2021",
    //   Achievements: "Ensured uninterupted CI/CD flow for UI build",
    // },
    {
      CompanyName: "Philips Lighting",
      specialization: "Intern  | Junior Developer",
      join: "Aug 2017",
      leave: "Aug 2018",
      tech: ["Javascript", "Html5", "Css3", "Git", "Github"],
      Achievements: [
        "Developed  SandBox environment for RESTful APIs that programs the simulation of Sensor devices.",
        "Developed Dashboard that generates the query-able  UI report on external CSV energy statistics using D3.js",
      ],
    },
  ],

  skills: [
    {
      skillname: "Html5",
    },
    {
      skillname: "Css3",
    },
    {
      skillname: "JavaScript",
    },
    {
      skillname: "Typescript",
    },
    {
      skillname: "React",
    },
    {
      skillname: "tailwind",
    },
    { skillname: "node" },
    {
      skillname: "nextjs",
    },
  ],
  portfolio: [
    {
      name: "Decathlon ecommerce -Professional",
      description: "Sells Sports products online with omni channel presence",
      imgurl: "images/decathlon.jpeg",
      tech: ["nextjs", "Html5", "Css3", "tailwind"],
      url: "https://www.decathlon.in",
    },
    {
      name: "Movie Explorer",
      description:
        "This Website is a simple search dashboard to explore the universities based on the important criterion. This is useful for the student who aspires to study abroad",
      imgurl: "images/alglia.jpeg",
      tech: ["Javascript", "Nextjs", "tailwind", "Html5", "Css3"],
      url: "https://movie-explorer-kujcwazhp-mohammedimtiyaz-1.vercel.app/",
    },
    {
      name: "The News App -",
      description:
        "This Website is a News app which fetches data from News API across major categories. The News are Relevant to the time.",
      imgurl: "images/news.jpeg",
      tech: ["nextjs", "free api", "Javascript", "Html5", "Css3"],
      url: "https://news-board-bay.vercel.app/",
    },
    {
      name: "University Explorer ",
      description:
        "This Website is a simple search dashboard to explore the universities based on the important criterion. This is useful for the student who aspires to study abroad",
      imgurl: "images/university.jpeg",
      tech: ["nextjs", "algolia", "Javascript", "Html5", "Css3"],
      url: "https://algoliasearch.versel.com/",
    },
    {
      name: "OpenBoard",
      description:
        "TDraws graphics with basic feature. Lets us understand the canvas api feature.Live connect with websocket",
      imgurl: "images/openboard.png",
      tech: ["websocket", "Javascript", "Html5", "Css3"],
      url: "hhttps://open-board-delta.vercel.app/",
    },
  ],
  certification: [
    {
      name: "Advance React core functionality",
      description: "React counrse",
      imgurl: "images/react3.png",
      tech: ["React"],
      url: "https://www.google.com",
    },

    {
      name: "Certificatin of Excellence for the year",
      description:
        "awarded for the contribution & growth of the Decahtlon Ecommerce",
      imgurl: "images/certificate.jpg",
      tech: ["scrum"],
      url: "https://www.google.com",
    },
    {
      name: " Certificate of JS Expert ",
      description: "Secured 92 % in JS on plural sight ",
      imgurl: "images/js_expert.png",
      tech: ["Javascript"],
      url: "https://www.scrum.org/resources/what-scrum-module",
    },
    {
      name: "Certified Scrum Practisioner",
      description: "2 days workshop on Certified Scrum Practisioner",
      imgurl: "images/scrum.webp",
      tech: ["Javascript"],
      url: "https://www.google.com",
    },
  ],
};

export default resumeData;
